import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { AppErrorContext } from '../../../models/app-error-context.model';
import { ErrorContextService } from '../../../services/error-context/error-context.service';

/**
 * Generic ("something went wrong") error screen (PLAN-2069).
 *
 * Shown when a server-side (5xx) request fails. It deliberately shows only non-sensitive metadata
 * (HTTP status, a request id for support, and a timestamp) — never the raw internal error message,
 * so internal errors are not exposed to the user.
 */
@Component({
  selector: 'gains-error-screen',
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule, NzButtonModule],
  templateUrl: './error-screen.component.html',
  styleUrl: './error-screen.component.scss'
})
export class ErrorScreenComponent implements OnInit {
  protected context: AppErrorContext | null = null;

  constructor(
    private readonly _router: Router,
    private readonly _errorContext: ErrorContextService
  ) {}

  ngOnInit(): void {
    this.context = this._errorContext.consumeError();
  }

  protected get timestamp(): Date {
    return this.context?.timestamp ?? new Date();
  }

  tryAgain(): void {
    const originUrl = this.context?.originUrl;
    if (originUrl && originUrl !== '/error') {
      this._router.navigateByUrl(originUrl);
      return;
    }
    this._router.navigate(['/home']);
  }

  // Location.back() would land on the page that just failed and re-trigger the same error,
  // so "Go back" leaves this screen for Home instead.
  goBack(): void {
    this._router.navigate(['/home']);
  }
}
